import integrationsService from "../services/integrations.service";

const readMessage = (resp, fallback) =>
  resp?.data?.data?.error ||
  resp?.data?.error ||
  resp?.data?.data?.message ||
  resp?.data?.message ||
  fallback;

const ok = (resp) => resp?.status === 200 || resp?.status === 201;

/**
 * Fetches the provider's authorize URL so the caller can send the browser to
 * it. Nothing is stored: the handshake finishes on the backend, which then
 * redirects back to /integrations with a status in the query string.
 *
 * @param {string} assistId
 * @param {string} provider "calendly" | "google-calendar"
 */
export const getIntegrationAuthorizeUrl =
  (assistId, provider) => async () => {
    if (!assistId) {
      return { success: false, message: "No assistant selected." };
    }

    const resp = await integrationsService.getAuthorizeUrl(assistId, provider);
    const authorizeUrl =
      resp?.data?.data?.authorizeUrl || resp?.data?.authorizeUrl;

    if (ok(resp) && authorizeUrl) {
      return { success: true, response: resp, authorizeUrl };
    }

    return {
      success: false,
      response: resp,
      message: readMessage(
        resp,
        ok(resp)
          ? "The server didn't return an authorization link."
          : "We couldn't start that connection. Please try again.",
      ),
    };
  };

/**
 * Revokes a connected provider. 204 is a normal answer to a DELETE, so it
 * counts as success alongside 200/201.
 */
export const disconnectIntegration = (assistId, provider) => async () => {
  if (!assistId) return { success: false, message: "No assistant selected." };

  const resp = await integrationsService.disconnect(assistId, provider);

  if (ok(resp) || resp?.status === 204) {
    return { success: true, response: resp };
  }

  return {
    success: false,
    response: resp,
    message: readMessage(resp, "We couldn't disconnect that integration."),
  };
};
